var _rect, _path, _rect2, _rect3, _rect4, _path2, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2045,
    y: 0.75,
    width: 3.04545,
    height: 18.5,
    rx: 1.52273,
    fill: "#C7BDFF",
    stroke: "#C7BDFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04545 17.5C4.04545 18.6505 3.208 19.5 2.27273 19.5C1.33745 19.5 0.5 18.6505 0.5 17.5C0.5 16.3495 1.33745 15.5 2.27273 15.5C3.208 15.5 4.04545 16.3495 4.04545 17.5Z",
    fill: "#7F6BF6",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "#7F6BF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "#7F6BF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3864,
    y: 5.75,
    width: 3.04545,
    height: 13.5,
    rx: 1.52273,
    fill: "#C7BDFF",
    stroke: "#C7BDFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04545 17.5C4.04545 18.6505 3.208 19.5 2.27273 19.5C1.33745 19.5 0.5 18.6505 0.5 17.5C0.5 16.3495 1.33745 15.5 2.27273 15.5C3.208 15.5 4.04545 16.3495 4.04545 17.5Z",
    fill: "#93FEB7",
    stroke: "#93FEB7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "#7F6BF6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.81818,
    y: 10,
    width: 4.54545,
    height: 10,
    rx: 2.27273,
    fill: "#7F6BF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalHalf);
export default __webpack_public_path__ + "static/media/signal_half.6dd83880084e6e8ce4d1e67c54ae0bb7.svg";
export { ForwardRef as ReactComponent };